import { render, staticRenderFns } from "./DSelect.vue?vue&type=template&id=685be5ee&"
import script from "./DSelect.vue?vue&type=script&lang=js&"
export * from "./DSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports